import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditAssignCourseLayer = () => {
  const location = useLocation();
  const AssignCourseToEdit = location.state?.assignCourse;
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    phone: "",
    // roll_no: "",
    address: "",
    gender: "",
    // admission_Date: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedTutor, setSelectedTutor] = useState("");
  const [tutors, setTutors] = useState([]);
  const [token, setToken] = useState("");
  const [courseCategories, setCourseCategories] = useState([]);
  //   const [courseCategories, setCourseCategories] = useState("");
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  useEffect(() => {
    // const token1 = localStorage.getItem("token");
    const token1 = localStorage.getItem("token");
    setToken(token1);
    if (!token1) {
      // console.log("Access required");
      return;
    }

    if (AssignCourseToEdit) {
      // console.log("assiign course info: ", AssignCourseToEdit);

      // setFormState({
      //   name: AssignCourseToEdit?.name,
      //   email: AssignCourseToEdit?.email,
      //   phone: AssignCourseToEdit?.mobile,
      //   address: AssignCourseToEdit?.address,
      //   gender: AssignCourseToEdit?.gender,
      //   trader_id: AssignCourseToEdit?.trader_id
      // });
      setSelectedDepartment(AssignCourseToEdit?.department?._id);
      setSelectedCourseCategory(AssignCourseToEdit?.courseCategory?._id);
      setSelectedCourse(AssignCourseToEdit?.course?._id);
      setSelectedTutor(AssignCourseToEdit?.tutor?._id);
      setLoading(false); // Stop loading after setting form state
    } else {
      setError("No tutor data found.");
      setLoading(false);
    }

    fetchdepartment();
    fetchAllCourses();
  }, []);

  useEffect(() => {
    fetchCourseCategories();
    fetchTutors();
    fetchCoursesByDepartment();
  }, [selectedDepartment, selectedCourseCategory]);

  const fetchCoursesByDepartment = async () => {
    if (!selectedDepartment) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses/${selectedDepartment}/${selectedCourseCategory}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCourses(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchCourseCategories = async () => {
    if (!selectedDepartment) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${selectedDepartment}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCourseCategories(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchAllCourses = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Course-nopagination`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setCourses(response.data.data); // Update to your API structure
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchTutors = async () => {
    if (!selectedDepartment) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const tutorResponse = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-tutor-bydept/${selectedDepartment}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setTutors(tutorResponse.data.data); // Update to your API structure
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchdepartment = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartments(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading state
    try {
      // const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
      }

      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/assigncourse-update/${AssignCourseToEdit._id}`,
        {
          selectedDepartment,
          selectedCourseCategory,
          selectedCourse,
          selectedTutor,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // // console.log("response   ::", response);

      if (response.status && response.status === 200) {
        // alert("Mobile number should be in numbers.");
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/assigncourse-list");
        }, 2000);
      }
    } catch (err) {
      if(err.response && err.response.status===401){
        setSnackbarMessage("This tutor is already assigned to the selected course.");
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      }else{
        setSnackbarMessage("Failed to update. Please try again");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      }
      console.error( err);
      
    } finally {
      setLoading(false); // End loading state
    }
  };

  return (
<div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        
          
            <div className="card h-100">
              <div className="card-body p-24">
                <form onSubmit={(e)=>handleSubmit(e)}>
                  {/* Department Selection */}
                  <div className="mb-20">
                    <label
                      htmlFor="department"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Department
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                      className="form-control radius-8 form-select"
                      id="department"
                      required
                      value={selectedDepartment || ""}
                      onChange={(e) =>
                        {
                          setSelectedCourse("");
                          setSelectedTutor("");
                          setSelectedCourseCategory("");
                          setSelectedDepartment(e.target.value || "");
                        }
                      }
                    >
                      <option value="" disabled>
                        Select a Department
                      </option>
                      {departments.map((department) => (
                        <option key={department?._id} value={department?._id}>
                          {department?.department_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Course Category Selection */}
                  <div className="mb-20">
                    <label
                      htmlFor="courseCategory"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Level
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                    required
                      className="form-control radius-8 form-select"
                      id="courseCategory"
                      value={selectedCourseCategory || ""}
                      onChange={(e) =>
                        setSelectedCourseCategory(e.target.value || "")
                      }
                    >
                      <option value="" disabled>
                        Select a Level
                      </option>
                      {courseCategories.length > 0 ? (
                        courseCategories.map((courseCategory) => (
                          <option
                            key={courseCategory._id}
                            value={courseCategory._id}
                          >
                            {courseCategory?.courseCategoryName}
                          </option>
                        ))
                      ) : (
                        <option value="">No Course Categories Available</option>
                      )}
                    </select>
                  </div>

                  {/* Tutor Selection */}
                  <div className="mb-20">
                    <label
                      htmlFor="tutor"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Select Tutor
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                    required
                      className="form-control radius-8 form-select"
                      id="tutor"
                      value={selectedTutor || ""}
                      onChange={(e) => setSelectedTutor(e.target.value || "")}
                    >
                      <option value="" disabled>
                        Select Tutor
                      </option>
                      {tutors.length > 0 ? (
                        tutors.map((tutor) => (
                          <option key={tutor._id} value={tutor._id}>
                            {tutor?.name}
                          </option>
                        ))
                      ) : (
                        <option value="">No Tutors Available</option>
                      )}
                    </select>
                  </div>

                  {/* Course Selection Radio Buttons */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Select Course<span className="text-danger-600">*</span>
                    </label>
                    <div>
                      {courses.map((course) => (
                        <div key={course?._id} className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            required
                            id={`course-${course?._id}`}
                            name="selectedCourse"
                            value={course?._id}
                            checked={selectedCourse === course?._id}
                            onChange={(e) =>
                              setSelectedCourse(e.target.value || "")
                            }
                          />
                          <label
                            htmlFor={`course-${course?._id}`}
                            className="form-check-label"
                          >
                            {course?.coursename}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                      onClick={() => navigate("/assigncourse-list")}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      
                    >
                      {loading && (
         <div className="loader-container" style={styles.loaderContainer}>
                                              <CircularProgress />
                                            </div>
                                          )}
                                            Save
                    </button>
                  </div>
                </form>
              </div>
         
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditAssignCourseLayer;
